import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { graphql } from 'react-apollo';
import styled from 'styled-components';
import { Telecos } from './querytrans';

const FilterWrapper = styled.div`
  float: right;
  padding-bottom: 8px;
  > select {
    width: 300px;
  }
`;

const QueryTelecos = graphql(Telecos, { name: 'telcos' });

class SelectOperator extends Component {
  handleChange = e => {
    this.props.onChange(e.target.value);
  };
  render() {
    const { telcos: { loading, error, telcos } } = this.props;
    if (loading || error) {
      return <FilterWrapper> Loading </FilterWrapper>;
    }

    return (
      <FilterWrapper>
        <Input type="select" name="select" onChange={e => this.handleChange(e)}>
          <option value="">Select Operator....</option>
          {telcos.map(cos => (
            <option key={cos.id} value={cos.name}>
              {cos.displayname}
            </option>
          ))}
        </Input>
      </FilterWrapper>
    );
  }
}

export default QueryTelecos(SelectOperator);



// WEBPACK FOOTER //
// ./src/views/Transactions/SelectOperator.js